module.exports = __webpack_public_path__ + "img/u5870.d969f468.png";